import { CustomerDetail } from "./customerApi"

export type CustomerHydration =
  | { kind: 'none' }
  | { kind: 'full'; data: CustomerDetail; hydratedId: number | null }
  | { kind: 'refresh'; data: CustomerDetail }

type Params = {
  newCustomer: CustomerDetail | null
  queryData: CustomerDetail | undefined
  hydratedId: number | null
  dirty: boolean
  photoDirty: boolean
}

export const decideCustomerHydration = ({ newCustomer, queryData, hydratedId, dirty, photoDirty }: Params): CustomerHydration => {
  if (newCustomer) {
    return { kind: 'full', data: newCustomer, hydratedId: null }
  }
  if (!queryData) {
    return { kind: 'none' }
  }
  if (hydratedId !== queryData.id) {
    return { kind: 'full', data: queryData, hydratedId: queryData.id }
  }
  if (!dirty && !photoDirty) {
    return { kind: 'refresh', data: queryData }
  }
  return { kind: 'none' }
}
